import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import reportWebVitals from './reportWebVitals'
import { Route, BrowserRouter, Routes } from 'react-router-dom'
import { AuthProvider } from './context/AuthProvider'
import App from './App'

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <React.StrictMode>
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/*" element={<App />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  </React.StrictMode>
);

// root.render(
//   <React.StrictMode>
//     <AuthProvider>
//       <RouterProvider router={router} />
//       {/* <App /> */}
//     </AuthProvider>
//   </React.StrictMode>
// );
reportWebVitals();
